import React from 'react'

import styled, { useTheme, css } from 'styled-components'

import { APP_DEFAULT_STATE } from '@api/local'
import { Heading, Paragraph, Spacer } from '@atoms/index'
import { PlansBoxShadow, ResponsivePXValue } from '@components/Theme'
import { useGetAppQuery } from '@hooks/api'
import { DeviceTypeEnum } from '@uctypes/api/globalTypes'

const Container = styled.div<{ $invertStyle?: boolean, $isMobile?: boolean, $hasSubHeading?: boolean }>`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
  
  background-color: ${(props): string => props.theme.colors.whites.pureWhite};
  ${ResponsivePXValue('max-width', { mobile: '90vw', tablet: '100vw', desktop: '1136px' })}
  ${ResponsivePXValue('width', { mobile: '90vw', tablet: '100%', desktop: '1136px' })}
  ${PlansBoxShadow}

  .section-heading, .section-sub-heading {
    background-color: ${(props): string => props?.$invertStyle ? props.theme.colors.whites.pureWhite : props.theme.colors.oranges.coral};

    ${({ $invertStyle }) => $invertStyle && css`
      color: ${(props): string => props.theme.colors.oranges.coral};
    `}
  }

  .section-heading {
    ${ResponsivePXValue('padding', { mobile: '16px', tablet: '16px', desktop: '16px 216px' })}
  }

  ${({ $hasSubHeading }) => $hasSubHeading && css`
    .section-heading {
      ${ResponsivePXValue('padding', '16px 16px 0 16px')}
    }
    .section-sub-heading {
      ${ResponsivePXValue('padding', '0 16px 16px 16px')}
    }
  `}

  .button-container{
    width: 100%;
  }
`

const ChildContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  ${ResponsivePXValue('padding', { mobile: '0 16px 16px', tablet: '0 16px 16px', desktop: '0 48px 48px' })}
`
export interface PlansSectionContainerProps {
  heading?: string
  subHeading?: string
  children: React.ReactNode

  invertStyle?: boolean
  className?: string
}
export function PlansSectionContainer({ heading, subHeading, className, children, invertStyle = false }: PlansSectionContainerProps): JSX.Element {

  const { data: appData = { app: { ...APP_DEFAULT_STATE } } } = useGetAppQuery()
  const theme = useTheme()
  const isMobile = appData.app.deviceType === DeviceTypeEnum.MOBILE

  return (
    <Container className={className} $invertStyle={invertStyle} $isMobile={isMobile} $hasSubHeading={!!subHeading}>
      <If condition={!!heading}>
        <Heading className='section-heading' align='center' variant='h2' color={theme.colors.whites.pureWhite}>{heading}</Heading>
      </If>
      <If condition={!!subHeading}>
        <Paragraph className='section-sub-heading' align='center' variant='p2' color={theme.colors.whites.pureWhite}>{subHeading}</Paragraph>
        <Spacer universal='16px' />
      </If>
      <ChildContainer>
        {children}
      </ChildContainer>
    </Container>
  )

}
